import { Carousel } from 'react-responsive-carousel';
import ReactPlayer from 'react-player';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { styled } from 'styled-components';

import { VIDEO_1, VIDEO_2 } from '../data/url';

const VideoCarouselWrapper = styled.div`
    margin: 10vw 0px;

    @media screen and (max-width: 768px) {
        aspect-ratio: 16/9;
    }

    .carousel-wrapper,
    .carousel,
    .carousel > .slider-wrapper,
    .carousel > .slider-wrapper > .slider {
        height: 100%;
    }

    .carousel-wrapper .carousel {
        overflow: visible;
    }

    .carousel-wrapper .carousel .control-dots {
        display: flex;
        justify-content: center;
        align-items: center;
        list-style-type: none;
        transform: translateY(40px);
    }

    .carousel-wrapper .carousel .control-dots li {
        margin: 0px 8px;
    }
    .scrollAnimation {
        width: 1024px;
        height: 576px;
        margin: 0 auto;
        @media screen and (max-width: 768px) {
            width: 100%;
            height: 100%;
        }
    }
`;

const VideoCarousel = () => {
    const indicatorRenderer = (
        clickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
        isSelected: boolean,
        index: number
    ) => {
        return (
            isSelected ? (
                <li
                    key={index}
                    style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '20px',
                        backgroundColor: '#45B9AE'
                    }}
                />
            ) : (
                <li
                    key={index}
                    value={index}
                    onClick={clickHandler}
                    onKeyDown={clickHandler}
                    style={{
                        width: '16px',
                        height: '16px',
                        borderRadius: '16px',
                        backgroundColor: '#DCF5F2',
                        cursor: 'pointer'
                    }}
                />
            )
        );
    };

    return (
        <VideoCarouselWrapper>
            <ScrollAnimation className='scrollAnimation' animateIn='fadeIn' animateOnce>
                <Carousel
                    className='carousel-wrapper'
                    autoPlay={false}
                    showArrows={false}
                    showStatus={false}
                    showThumbs={false}
                    renderIndicator={indicatorRenderer}
                >
                    <ReactPlayer url={VIDEO_1} controls width='100%' height='100%' />
                    <ReactPlayer url={VIDEO_2} controls width='100%' height='100%'/>
                </Carousel>
            </ScrollAnimation>
        </VideoCarouselWrapper>
    );
};

export default VideoCarousel;
